import React, { useState, useEffect } from 'react';
import { CgMenuLeftAlt, CgPushChevronRight } from "react-icons/cg";
import { AiOutlineUser } from "react-icons/ai";
import { FiArrowRight } from 'react-icons/fi';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './NavBar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50 || location.pathname !== '/') {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location]);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const closeDropdown = () => setIsDropdownOpen(false);

  const handleReservationChambreClick = () => navigate('/Reservation');
  const handleConnexionClick = () => navigate('/Connexion');

  const navigateToSection = (id) => {
    if (location.pathname === '/') {
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollToId: id } });
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-menu">
          <div className="navbar-hamburger" onClick={toggleDropdown}>
            <div className="fil"></div>
            <CgMenuLeftAlt className="hamburger-icon" />
            <span>Menu</span>
          </div>
          {isDropdownOpen && (
            <>
              <div className="dropdown-overlay visible" onClick={closeDropdown} />
              <div className="navbar-dropdown">
                <h3>
                  Menu
                  <CgPushChevronRight className="retourarriere-icon" onClick={toggleDropdown} />
                </h3>
                <a onClick={() => { navigateToSection('accueil'); closeDropdown(); }}>Accueil</a>
                <Link to="/AobergeC" onClick={closeDropdown}>Chambres</Link>
                <Link to="/AobergeS" onClick={closeDropdown}>Suites</Link>
                <a onClick={() => { navigateToSection('restauration'); closeDropdown(); }}>Restauration</a>
                <a onClick={() => { navigateToSection('services'); closeDropdown(); }}>Services</a>
                <a onClick={() => { navigateToSection('gallerie'); closeDropdown(); }}>Gallerie</a>
                <Link to="/Article" onClick={closeDropdown}>Articles</Link>
                <a onClick={() => { navigateToSection('contact'); closeDropdown(); }}>Contact</a>
              </div>
            </>
          )}
        </div>

        <div className="navbar-logo">
          <div className="fil"></div>
          Syphax Hotel
        </div>

        <div className='connexion'>
          <div className="fil"></div>
          <AiOutlineUser className='connexion-icon' onClick={handleConnexionClick} />
          <span>Connexion</span>
        </div>

        <div className="navbar-reserve">
          <button className="reserve-button" onClick={handleReservationChambreClick}>
            <span className="button-content">
              Reserver <FiArrowRight className="icon-arrow" size={18} />
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
